export class Bezoek {
  constructor() {
    this.Datum = null;
    this.Bijbelgedeelte = null;
    this.Bijzonderheden = null;
  }
}